import { Button, Form, Input, Select, Drawer, Popover } from 'antd'
import React, { useState, useContext, useEffect } from 'react'
import { get } from 'lodash'
import _map from 'lodash/map'
import client from 'apollo'
import { FilterOutlined, DownloadOutlined } from '@ant-design/icons'

import '../index.css'
import NoData from 'components/NoData'
import { AppContext } from 'AppContext'
import Page404 from 'components/Page404'
import Loader from 'components/loaders/Loader'
import history from 'CustomHistory'
import { GET_STRATEGY_LIST } from 'modules/Settings/graphql/Queries'
import {
  SP_CURRENT_POSITIONEQ,
  GET_REPORT_CLIENT_USERS_FOR_STAFF,
} from '../graphql/Queries'
// import DownloadReport from '../DownloadReport'
import PositionEQTable from './PositionEQTable'
import FilterBackButton from 'assets/images/new-images/filter-back-button.svg'
import PdfIcon from 'assets/images/new-images/pdficon.svg'
import ExcelIcon from 'assets/images/new-images/excelIcon.svg'
import { exportGraphAsPdf } from 'utils/Graph'
import { CSVLink } from 'react-csv'
import { getName, canUserExport, canUserDownload } from 'utils/User'
import CustomMeta from 'components/CustomMeta'

const { Option } = Select

export default function () {
  const [form] = Form.useForm()
  const [strategyList, setStrategyList] = useState([])
  const [open, setOpen] = useState(false)
  const {
    state: {
      isClient,
      isMobile,
      currentUser: { clientCode, userName, strategyCode },
      userPermissions,
    },
    dispatch,
  } = useContext(AppContext)

  const hasExport = canUserExport(userPermissions, isClient)
  const hasDownload = canUserDownload(userPermissions, isClient)
  const [filters, setFilters] = useState({
    clientCode: isClient ? clientCode || '' : '',
    userName: isClient ? userName || '' : '',
    strategyCode: isClient ? strategyCode || '' : '',
    strategy: '',
    script: '',
  })
  const showFilters = get(history, 'location.pathname') === '/' && !isClient
  useEffect(() => {
    dispatch({ type: 'SELECTED_GROUP', data: undefined })
    dispatch({ type: 'SELECTED_STRATEGY', data: 'ILTS' })
  }, [dispatch, showFilters])

  const [data, setData] = useState()
  const [clientListLoading, setClientListLoading] = useState(false)
  const [reportLoading, setReportLoading] = useState(true)
  const [error, setError] = useState(false)
  const [staffData, setStaffData] = useState([])

  const loadClientUsers = () => {
    setClientListLoading(true)
    setError(false)
    client
      .query({
        query: GET_REPORT_CLIENT_USERS_FOR_STAFF,
        variables: { where: {}, limit: 1000000 },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        const users =
          res?.data?.getClientUsersForStaff?.users?.filter(
            (user) => user?.clientCode,
          ) || []
        setStaffData(users)
      })
      .catch((err) => {
        setError(err)
      })
      .finally(() => {
        setClientListLoading(false)
      })
  }

  useEffect(() => {
    if (!isClient) return

    setFilters((prevFilters) => {
      if (
        prevFilters?.clientCode === (clientCode || '') &&
        prevFilters?.userName === (userName || '') &&
        prevFilters?.strategyCode === (strategyCode || '')
      ) {
        return prevFilters
      }

      return {
        ...prevFilters,
        clientCode: clientCode || '',
        userName: userName || '',
        strategyCode: strategyCode || '',
      }
    })
  }, [clientCode, userName, strategyCode, isClient])

  const selectedClient =
    !isClient && filters?.clientCode
      ? staffData.find(
          (user) =>
            user?.clientCode === filters?.clientCode &&
            user?.userName === filters?.userName
        )
      : undefined

  useEffect(() => {
    if (isClient && !filters?.clientCode) {
      setReportLoading(false)
      return
    }

    setReportLoading(true)
    setError(false)
    const reportUserName = isClient ? userName || '' : selectedClient?.userName || ''
    const reportStrategyCode = filters?.strategy
      ? filters?.strategy
      : isClient
        ? strategyCode || ''
        : selectedClient?.strategyCode || ''

    client
      .query({
        query: SP_CURRENT_POSITIONEQ,
        variables: {
          where: {
            ...filters,
            clientCode: filters?.clientCode,
            userName: reportUserName,
            strategyCode: reportStrategyCode,
          },
        },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        setData(res?.data)
      })
      .catch((err) => {
        setError(err)
      })
      .finally(() => {
        setReportLoading(false)
      })
  }, [filters, isClient, selectedClient, userName, strategyCode])

  useEffect(() => {
    client
      .query({ query: GET_STRATEGY_LIST, fetchPolicy: 'network-only' })
      .then((res) => {
        setStrategyList(res.data.getStrategyList)
      })
  }, [])

  if (reportLoading) return <Loader />
  if (error) return <Page404 error={error} />

  let currentPositionEQBalanceData
  const spCurrentPositionEQ = get(data, 'spCurrentPositionEQ', [])
  const hasReportData = spCurrentPositionEQ.length > 0
  currentPositionEQBalanceData = spCurrentPositionEQ.map((EqBalance) => {
    return {
      ...EqBalance,
      qty: Math.round(EqBalance.qty),
      Value: Math.round(EqBalance.Value),
      NetPrice: EqBalance.NetPrice,
    }
  })

  const columns = [
    {
      title: 'EQ Position Report',
      className: 'report-title main-title',
      children: [
        {
          title: 'Client Code',
          dataIndex: 'ClientCode',
          key: 'ClientCode',
          width: isMobile && 80,
          className: 'report-text',
        },
        {
          title: 'Strategy Code',
          dataIndex: 'StrategyCode',
          key: 'StrategyCode',
          width: isMobile && 100,
          className: 'report-numeric',
        },
        {
          title: 'Script',
          dataIndex: 'script',
          key: 'script',
          width: isMobile ? 150 : '15%',
          className: 'report-numeric',
        },
        {
          title: 'qty',
          dataIndex: 'qty',
          key: 'qty',
          width: isMobile ? 100 : '15%',
          className: 'report-numeric',
        },
        {
          title: 'Value',
          dataIndex: 'Value',
          key: 'Value',
          width: '20%',
          className: 'report-numeric',
          render: (text) => text,
        },
        {
          title: 'Net Price',
          dataIndex: 'NetPrice',
          key: 'NetPrice',
          width: isMobile && 100,
          className: 'report-numeric',
          render: (text) => text.toFixed(2),
        },
      ],
    },
  ]

  const onFinish = (values) => {
    const selectedUser = !isClient
      ? staffData.find((u) => u.userName === values?.clientCode)
      : null

    setFilters({
      ...values,
      clientCode: isClient ? clientCode || '' : (selectedUser?.clientCode || ''),
      userName: isClient ? userName || '' : (selectedUser?.userName || ''),
      strategyCode: isClient ? strategyCode || '' : (selectedUser?.strategyCode || ''),
      strategy: values.strategy ? values.strategy : '',
      script: values.script ? values.script : '',
    })
    setOpen(false)
  }

  const showDrawer = () => {
    if (!isClient && !staffData.length && !clientListLoading) {
      loadClientUsers()
    }
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
  }

  const handleDownloadPdf = () => {
    exportGraphAsPdf(
      'current-positionEQ',
      'SP_CURRENT_POSITIONFO_PDF',
      null,
      true
    ).finally(() =>
      console.log(' ====== current-positionEQ downloaded ====== ')
    )
  }
  const content = (
    <div style={{ width: '100px' }}>
      {hasDownload && (
        <div
          onClick={handleDownloadPdf}
          style={{
            marginBottom: `${isMobile ? '0px' : '10px'}`,
            fontSize: '14px',
            fontWeight: '600',
            lineHeight: '24px',
            textAlign: 'left',
            color: ' #000',
            cursor: 'pointer',
          }}
        >
          <img src={PdfIcon} style={{ marginRight: '10px' }} alt='pdf' /> PDF
        </div>
      )}

      {hasExport && (
        <CSVLink
          style={{ paddingRight: 0 }}
          data={currentPositionEQBalanceData?.map((item) => {
            return {
              ...item,
              Value: item?.Value?.toFixed(2),
              NetPrice: item?.NetPrice?.toFixed(2),
            }
          })}
          className='csv-btn'
          filename={`current-positionEQ`}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              marginBottom: `${isMobile ? '0px' : '10px'}`,
              fontSize: '14px',
              fontWeight: '600',
              lineHeight: '24px',
              textAlign: 'left',
              color: ' #000',
              cursor: 'pointer',
            }}
          >
            <img src={ExcelIcon} style={{ marginRight: '10px' }} alt='excel' />{' '}
            Excel
          </div>
        </CSVLink>
      )}
    </div>
  )

  return (
    <>
      <CustomMeta title='Report | Position EQ' />
      {/* <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          margin: 0,
        }}
      >
        {!error && (
          <DownloadReport
            data={currentPositionEQBalanceData}
            fileName='current-positionEQ'
            id='SP_CURRENT_POSITIONFO_PDF'
          />
        )}
      </div> */}

      <Drawer
        title={null}
        headerStyle={{ display: 'none' }}
        closable={false}
        placement='right'
        onClose={onClose}
        visible={open}
        width={472}
      >
        <div className='Filter_Form'>
          <div onClick={onClose}>
            <img src={FilterBackButton} alt='FilterBackButton' />
          </div>
          <div className='filter_panel_heading'>Filter</div>
        </div>

        <Form
          form={form}
          onFinish={onFinish}
          name='advanced_search'
          style={{ marginTop: '16px' }}
          layout='vertical'
          className='client-detail-form'
        >
          <div className='filter_Form_div_Container'>
            {!isClient && (
              <Form.Item name='clientCode' label='Select Client Code'>
                <Select
                  style={{ width: '100%' }}
                  getPopupContainer={(trigger) => trigger.parentElement}
                  className='display-field'
                  showSearch
                  loading={clientListLoading}
                  placeholder='Select Client Code'
                  optionFilterProp='title'
                  filterOption={(input, option) => {
                    const searchableValues = [option?.title, option?.value]
                    return searchableValues.some((value) =>
                      value?.toLowerCase().includes(input.toLowerCase())
                    )
                  }}
                >
                  {!clientListLoading &&
                    staffData &&
                    staffData.map((user, key) => {
                      return (
                        <Option
                          key={key}
                          value={user?.userName}
                          title={`${user?.clientCode} - ${getName(user)} ${user?.plan?.name ? `(${user?.plan?.name})` : ''}`}
                        >
                          {user?.clientCode}-{getName(user)}{' '}
                          {user?.plan?.name ? `(${user?.plan?.name})` : ''}
                        </Option>
                      )
                    })}
                </Select>
              </Form.Item>
            )}

            <Form.Item name='script' label='script'>
              <Input placeholder='Enter script' style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item name='strategy' label='strategy'>
              <Select
                // style={{ width: 80 }}
                getPopupContainer={(trigger) => trigger.parentElement}
                className='gx-mr-3 gx-select-sm'
                onChange={(e) =>
                  dispatch({ type: 'SELECTED_STRATEGY', data: e })
                }
              >
                {_map(strategyList, (strategy, key) => {
                  const { StrategyName, StrategyCode } = strategy
                  return (
                    <Option value={StrategyCode} key={key}>
                      {StrategyName}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          </div>
          <div className='filter_panel_button'>
            <Button
              onClick={() => {
                form.resetFields()
                setFilters({
                  clientCode: isClient ? clientCode || '' : '',
                  userName: isClient ? userName || '' : '',
                  strategyCode: isClient ? strategyCode || '' : '',
                  strategy: '',
                  script: '',
                })
                setOpen(false)
              }}
            >
              Clear
            </Button>
            <Button type='primary' htmlType='submit'>
              Search
            </Button>
          </div>
        </Form>
      </Drawer>

      {error ? (
        <Page404 error={error} isShow={false} />
      ) : (
        <div className='report_Container'>
          <div className='container_Header'>
            <div className='report_Heading'>Position EQ</div>

            <div className='container_Export_Popover'>
              {(hasExport || hasDownload) && !error && hasReportData ? (
                <Popover content={content} placement='bottom' trigger='click'>
                  <div className='container_Export_Popover'>
                    <Button>
                      Export{' '}
                      <DownloadOutlined
                        color='#AF0000'
                        style={{ fontSize: '16px' }}
                      />
                    </Button>
                  </div>
                </Popover>
              ) : (
                ''
              )}

              <Button
                style={{
                  color: '#000000',
                  border: '1px solid #919EAB52',
                  backgroundColor: 'white',
                }}
                onClick={showDrawer}
              >
                Filter{' '}
                <FilterOutlined color='#000000' style={{ fontSize: '16px' }} />
              </Button>
            </div>
          </div>
          <div
            className='report-table-wrapper'
            id='SP_CURRENT_POSITIONFO_PDF'
          >
            {hasReportData ? (
              <PositionEQTable
                filters={filters}
                data={currentPositionEQBalanceData}
                columns={columns}
                loading={reportLoading}
              />
            ) : (
              <NoData />
            )}
          </div>
        </div>
      )}
    </>
  )
}
